import { render, staticRenderFns } from "./portal-wrapper.vue?vue&type=template&id=2ddfa019&"
import script from "./portal-wrapper.vue?vue&type=script&lang=js&"
export * from "./portal-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./portal-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports